import { useEffect, useState } from "react";

import resolveZdrojeList from "b2b/utils/zdroj/resolveZdrojeList";

import useTypyZdroje from "./useTypyZdroje";

export default function useZdrojeFromZdrojeTyp() {
  const [zdroje, setZdroje] = useState();
  const { data: typyZdroju, ...state } = useTypyZdroje();

  useEffect(() => {
    if (typyZdroju) {
      setZdroje(resolveZdrojeList(typyZdroju));
    }
  }, [typyZdroju]);

  return { ...state, data: zdroje };
}
